//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Vue from "vue";
import ElementUI from 'element-ui';

Vue.use(ElementUI);


export default {
  name: "userhead",
  data() {
    return {
      imageUrl: undefined,
    }
  },
  props: {
    userinfo: undefined,
  },
  created() {
    this.imageUrl = this.generate_avatar_url(this.userinfo);
  },
  methods: {
    on_added: function (files) {
      console.log("files:", files);
    },
    handleAvatarSuccess(res, file) {
      console.log("handleAvatarSuccess:", res, file);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.$message('修改头像成功！', {
        type: "error",
      });
    },
    beforeAvatarUpload(file) {
      console.log("file:", file);
      const isImage = file.type.indexOf('image') >= 0;
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message.error('上传头像图片只能是有效的图片格式！');
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return isImage && isLt5M;
    },
  }
}
